import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";

var _class, _temp2;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from "react";
import CreatableSelect from "react-select/creatable";
import { theme, getSelectOptionColorByIndex } from "./styles";

var dot = function dot() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "#ccc";
  return {
    alignItems: "center",
    display: "flex",
    ":before": {
      backgroundColor: color,
      borderRadius: 10,
      content: '" "',
      display: "block",
      marginRight: 8,
      height: 10,
      width: 10
    }
  };
};

var styles = {
  container: function container(provided) {
    return _extends({}, provided, {
      flexGrow: 1
    });
  },
  control: function control(provided) {
    return _extends({}, provided, {
      border: "none",
      boxShadow: "none"
    });
  },
  option: function option(provided, _ref) {
    var data = _ref.data;
    return _extends({}, provided, {
      padding: "2px 6px"
    }, dot(data.color));
  },
  singleValue: function singleValue(provided, _ref2) {
    var data = _ref2.data;
    return _extends({}, provided, {
      paddingLeft: 6,
      paddingRight: 6,
      borderRadius: 5,
      backgroundColor: data.color
    });
  },
  menuList: function menuList(provided) {
    return _extends({}, provided, {
      fontFamily: theme.typography.fontFamily,
      paddingTop: 6,
      paddingBottom: 6
    });
  }
};
var CreatableSingle = (_temp2 = _class = function (_Component) {
  _inherits(CreatableSingle, _Component);

  function CreatableSingle() {
    var _temp, _this, _ret;

    _classCallCheck(this, CreatableSingle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
          onNewOption = _this$props.onNewOption,
          onSetOption = _this$props.onSetOption;

      switch (actionMeta.action) {
        case "create-option":
          {
            onNewOption(newValue.label);
            onSetOption(newValue.label);
            break;
          }

        case "select-option":
          {
            onSetOption(newValue.label);
            break;
          }

        case "clear":
          {
            onSetOption(null);
            break;
          }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CreatableSingle.prototype.render = function render() {
    var _props = this.props,
        value = _props.value,
        options = _props.options,
        props = _objectWithoutProperties(_props, ["value", "options"]);

    options = options.map(function (option, i) {
      return _extends({}, option, {
        label: option.value,
        color: getSelectOptionColorByIndex(i)
      });
    });
    value = value && options.find(function (option) {
      return option.value === value;
    });
    return React.createElement(CreatableSelect, _extends({
      isClearable: true,
      onChange: this.handleChange,
      options: options,
      styles: styles,
      theme: function theme(_theme) {
        return _extends({}, _theme, {
          spacing: {
            baseUnit: 0.5,
            controlHeight: 20,
            menuGutter: 3
          }
        });
      },
      value: value,
      placeholder: null,
      noOptionsMessage: function noOptionsMessage() {
        return "empty (type to create)";
      }
    }, props));
  };

  return CreatableSingle;
}(Component), _class.defaultProps = {
  onNewOption: function onNewOption() {},
  onSetOption: function onSetOption() {}
}, _temp2);
export default CreatableSingle;